// 吃瓜线路 首页 mock 数据（静态展示，不接接口）

export interface EntryItem {
  code: string;
  name: string;
  status: "ok" | "busy" | "standby";
  statusText: string;
  address: string;
  note: string;
  latency: string;
}

export const entrances: EntryItem[] = [
  {
    code: "LINE-01",
    name: "主入口",
    status: "ok",
    statusText: "正常",
    address: "chigua-line.app",
    note: "推荐优先，速度最快",
    latency: "12ms",
  },
  {
    code: "LINE-02",
    name: "备用线路 A",
    status: "ok",
    statusText: "正常",
    address: "cgline.top",
    note: "主入口拥挤时可切这里",
    latency: "38ms",
  },
  {
    code: "LINE-03",
    name: "备用线路 B",
    status: "busy",
    statusText: "高峰",
    address: "qxl-app.com",
    note: "建议错峰或使用缓存通道",
    latency: "120ms",
  },
  {
    code: "LINE-04",
    name: "永久地址",
    status: "standby",
    statusText: "待命",
    address: "chi-gua.site",
    note: "永久域名，防屏蔽自动切换",
    latency: "—",
  },
];

export interface FlashItem {
  time: string;
  tag: string;
  title: string;
  summary: string;
  hot: string;
  image?: string;
}

export const flashes: FlashItem[] = [
  {
    time: "2026.09.07",
    tag: "新瓜速递",
    title: "本周最热：档期与阵容信息连环放出",
    summary: "站内讨论量一路走高，回帖集中在演员配置与播出平台猜测，主讨论串已过千层。",
    hot: "1.2w",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20clapperboard%20and%20film%20reels%20with%20warm%20amber%20spotlight%20beams%20behind%2C%20editorial%20flat%20illustration%2C%20minimal%20background%2C%20no%20text&width=480&height=270&seq=flash-film-01&orientation=landscape",
  },
  {
    time: "2026.09.06",
    tag: "实时追踪",
    title: "某综艺录制花絮引路透，讨论区翻页快",
    summary: "录制现场相关话题热度不减，粉丝向与非粉丝向视角观点分化，管理组已置顶文明讨论帖。",
    hot: "8600",
    image:
      "https://readdy.ai/api/search-image?query=television%20backstage%20with%20colorful%20stage%20lights%20and%20camera%20silhouette%2C%20warm%20orange%20cream%20palette%2C%20editorial%20flat%20illustration%2C%20no%20text&width=480&height=270&seq=flash-show-02&orientation=landscape",
  },
  {
    time: "2026.09.05",
    tag: "行业观察",
    title: "暑期档收官：谁在口碑与热度之间站稳",
    summary: "从排片到二创，本号整理了一组视角。数据仍来自公开口径，欢迎理性补充。",
    hot: "5400",
  },
  {
    time: "2026.09.04",
    tag: "红毯直击",
    title: "年度活动阵容官宣，服装与互动成热议点",
    summary: "红毯现场图集与出场顺序已整理成索引帖，造型盘点内容最受欢迎。",
    hot: "1.5w",
    image:
      "https://readdy.ai/api/search-image?query=empty%20red%20carpet%20with%20velvet%20rope%20and%20flashing%20camera%20silhouettes%20at%20night%2C%20warm%20editorial%20illustration%2C%20no%20text&width=480&height=270&seq=flash-redcarpet-04&orientation=landscape",
  },
  {
    time: "2026.09.03",
    tag: "音乐现场",
    title: "音乐节阵容与歌单索引已同步",
    summary: "分场时间线整理完毕，主页入口提供歌单与场馆指引，方便按需取用。",
    hot: "3100",
    image:
      "https://readdy.ai/api/search-image?query=concert%20stage%20from%20behind%20with%20warm%20spotlight%20haze%20and%20confetti%2C%20orange%20amber%20tones%2C%20editorial%20flat%20illustration%2C%20no%20text&width=480&height=270&seq=flash-music-05&orientation=landscape",
  },
];

export interface CollectionCard {
  title: string;
  category: string;
  cover: string;
  summary: string;
  posts: string;
  update: string;
}

export const collections: CollectionCard[] = [
  {
    title: "影视档期专题",
    category: "剧集",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20set%20with%20vintage%20projector%20light%20beams%20and%20film%20reels%2C%20moody%20warm%20amber%20tones%2C%20editorial%20illustration%20poster%20style%2C%20abstract%20minimal%2C%20no%20text&width=900&height=600&seq=col-film-01&orientation=landscape",
    summary: "Q4 待播与在播重点剧集档期、班底与口碑动向集合。",
    posts: "128 帖",
    update: "2 小时前更新",
  },
  {
    title: "综艺录制观察",
    category: "综艺",
    cover:
      "https://readdy.ai/api/search-image?query=television%20studio%20backstage%20with%20colorful%20stage%20lights%20and%20camera%20silhouettes%2C%20warm%20orange%20and%20cream%20palette%2C%20editorial%20flat%20illustration%2C%20minimal%2C%20no%20text&width=900&height=600&seq=col-show-02&orientation=landscape",
    summary: "录制花絮、阵容变动与节目对比索引，快速定位讨论串。",
    posts: "96 帖",
    update: "5 小时前更新",
  },
  {
    title: "红毯造型盘点",
    category: "现场",
    cover:
      "https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20with%20soft%20warm%20bokeh%20lights%20and%20velvet%20curtain%2C%20elegant%20editorial%20illustration%2C%20warm%20gold%20amber%20tones%2C%20no%20text&width=900&height=600&seq=col-gala-03&orientation=landscape",
    summary: "近期活动现场造型、穿搭与出场细节一站式集合。",
    posts: "211 帖",
    update: "昨天",
  },
  {
    title: "音乐节现场",
    category: "演出",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20silhouettes%20under%20warm%20sunset%20stage%20lights%2C%20editorial%20illustration%2C%20amber%20orange%20tones%2C%20minimal%2C%20no%20text&width=900&height=600&seq=col-live-04&orientation=landscape",
    summary: "阵容时间线、歌单与场馆指引，现场党必备。",
    posts: "73 帖",
    update: "昨天",
  },
  {
    title: "选秀与新生代",
    category: "新人",
    cover:
      "https://readdy.ai/api/search-image?query=audition%20room%20spotlight%20with%20microphone%20and%20red%20stage%20numbers%2C%20warm%20tones%2C%20editorial%20flat%20illustration%2C%20minimal%20background%2C%20no%20text&width=900&height=600&seq=col-talent-05&orientation=landscape",
    summary: "新生代动态、节目表现与作品记录持续更新。",
    posts: "89 帖",
    update: "2 天前",
  },
  {
    title: "行业与舆情风向",
    category: "观察",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20printed%20news%20pages%20with%20a%20magnifying%20glass%20and%20scattered%20red%20chili%20peppers%20on%20a%20desk%2C%20warm%20editorial%20still%20life%2C%20cozy%20minimal%2C%20no%20text&width=900&height=600&seq=col-trend-06&orientation=landscape",
    summary: "行业动作与舆情走向的非结论式观察合集。",
    posts: "152 帖",
    update: "2 天前",
  },
];

export interface TopicTile {
  name: string;
  icon: string;
  desc: string;
  count: string;
  trend: "up" | "flat" | "down";
}

export const topics: TopicTile[] = [
  { name: "影视剧", icon: "ri-film-line", desc: "档期 · 口碑 · 阵容", count: "1.2k", trend: "up" },
  { name: "综艺", icon: "ri-tv-2-line", desc: "花絮 · 阵容变动", count: "986", trend: "up" },
  { name: "现场红毯", icon: "ri-sparkling-2-line", desc: "造型 · 出场 · 细节", count: "1.5k", trend: "flat" },
  { name: "音乐演出", icon: "ri-music-2-line", desc: "歌单 · 阵容 · 场馆", count: "642", trend: "flat" },
  { name: "选秀新生代", icon: "ri-user-star-line", desc: "舞台 · 作品记录", count: "880", trend: "down" },
  { name: "行业观察", icon: "ri-line-chart-line", desc: "动作 · 舆情 · 风向", count: "720", trend: "up" },
  { name: "榜单速报", icon: "ri-command-line", desc: "热度 · 排行 · 环比", count: "1.1k", trend: "flat" },
  { name: "补档合集", icon: "ri-archive-2-line", desc: "回放 · 索引 · 收藏", count: "2.3k", trend: "up" },
];

export interface GuideStep {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export const guideSteps: GuideStep[] = [
  {
    step: "01",
    title: "记下永久地址",
    desc: "把本页最上方的永久地址复制进备忘录或收藏夹，作为长期锚点，别只记临时入口。",
    icon: "ri-bookmark-line",
  },
  {
    step: "02",
    title: "打不开就切线路",
    desc: "主入口高峰拥挤时，依次切换下方备用线路 A / B，通常秒开；仍卡顿就刷新一次。",
    icon: "ri-shuffle-line",
  },
  {
    step: "03",
    title: "关注公告栏",
    desc: "地址如有调整，会第一时间在本页公告栏与顶部状态位更新，看到提示再更新收藏。",
    icon: "ri-notification-3-line",
  },
  {
    step: "04",
    title: "需要时用客户端",
    desc: "访问不稳定期间，可通过底部「下载客户端」走独立通道，体验更顺也更稳。",
    icon: "ri-download-2-line",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "为什么主入口会偶尔打不开？",
    a: "高峰时段并发较高或网络链路波动时可能出现短暂卡顿。这不代表站点异常，直接切换到下方备用线路 A / B，通常即可正常访问。",
  },
  {
    q: "永久地址和备用地址有什么区别？",
    a: "永久地址是本站长期稳定的域名锚点，适合收藏；备用地址是临时分发通道，用于在主入口波动时快速顶上。两者指向的内容一致，可互相切换。",
  },
  {
    q: "地址变了会提前通知吗？",
    a: "会的。任何地址调整都会在顶部状态栏与本页公告区同步提示，并把最新的备用入口置顶展示。建议把永久地址加入收藏夹以便随时回本页确认。",
  },
  {
    q: "客户端与网页有什么区别？",
    a: "客户端走独立通道，在访问不稳定的环境下通常更稳定，也支持更沉浸的浏览体验。日常浏览直接使用网页入口即可，两者数据互通。",
  },
];

export const notices: string[] = [
  "通道高峰拥挤：若主入口卡顿，请直接切换备用线路 A。",
  "永久地址已更新并置顶，请以本页公告为准，谨防仿冒。",
  "页面打不开时先刷新一次，仍不行再换线路，不要反复重试同一入口。",
];